import React, { Component } from "react";
import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBRow,
    MDBCol,
    MDBIcon,
    toast,
    MDBCard,
    MDBCardBody,
} from "mdbreact";
import axios from "../../../axios";
import "react-day-picker/lib/style.css";
import dateFnsFormat from "date-fns/format";
import Data from "../../../components/SubscriberMgmt/CumulativeBandwidth/Datachart/datachart";
import AddProfile from "../../../components/SubscriberMgmt/AddProfile/AddProfile";
import DeviceDetails from "../../../components/SubscriberMgmt/DeviceInformation/DeviceDetails";
import { withTranslation } from "react-i18next";
import AllWifiKeysTable from "../../../components/SubscriberMgmt/KeyInformation/Datatables/AllWifiKeysMoreDetailsTable";
import PasswordConditions from "../../../components/SubscriberMgmt/PasswordValidator/PasswordConditions";
import LinearProgress from '@mui/material/LinearProgress';
class KeyManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading1: false,
            toggleEdit: "disabled",
            showPassword: true,
            modalEditNickname: false,
            modalEditPassword: false,
            venueName: this.props.venueName,
            selectedKeyName:
                this.props.keyInfo[0][this.props.venueName][
                    this.props.keyID
                ] !== undefined
                    ? this.props.keyInfo[0][this.props.venueName][
                          this.props.keyID
                      ]["KeyTag"]
                    : "",
            selectedKeyID: this.props.keyID,
            password:
                this.props.password !== null
                    ? this.props.password
                    : this.props.firstPSK,
            token: this.props.token,
            tag:
                this.props.keyInfo[0][this.props.venueName][
                    this.props.keyID
                ] !== undefined
                    ? this.props.keyInfo[0][this.props.venueName][
                          this.props.keyID
                      ]["psk"].split(".")[1]
                    : "",
            category: [],
            name: [],
            data: [],
            dot: true,
            passwordInvalid: false,
            count: 0,
            submittingPSKReset: false,
        };
    }
    toggleAddProfile = () => {
        this.setState({
            modalAddProfile: !this.state.modalAddProfile,
        });
    };
    toggleEditNickname = () => {
        this.setState({
            selectedKeyName: this.props.selectedKeyName,
            modalEditNickname: !this.state.modalEditNickname,
        });
    };
    toggleEditPassword = () => {
        this.setState({
            password: this.props.password,
            modalEditPassword: !this.state.modalEditPassword,
            count: 0,
            // newpsk: "",
            lowercase: false,
            uppercase: false,
            charLength: false,
            number: false,
            updatedpsk: null,
        });
    };
    togglePassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };
    toggleEdit = () => {
        this.setState({ toggleEdit: !this.state.toggleEdit });
    };
    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    setPassword = (newpassword, password, token) => {
     // console.log(token)
        let scrubbedPassword = newpassword.replace(/\./g, "");
        // console.log("🚀 ~ file: KeyInformation.js:245 ~ KeyInformation ~ newpassword:", scrubbedPassword)
        this.setState({ password: scrubbedPassword });
        this.setState({ token: token });
        this.passwordValidate(scrubbedPassword);
    };
    toggleDeviceDetails = (device) => {
        this.setState({
            modalDeviceDetails: !this.state.modalDeviceDetails,
            deviceDetails: device,
        });
    };
    toggleDeviceDetailsClose = () => {
        this.setState({
            modalDeviceDetails: !this.state.modalDeviceDetails,
        });
    };
    submitEditNickname = () => {
        const { t } = this.props;
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            KeyID: this.props.keyID,
            KeyTag: this.state.selectedKeyName,
        };
        axios
            .post("/subscriberconsole/updateKeyTag", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    modalEditNickname: !this.state.modalEditNickname,
                });
                toast.success(t("profiledetails.nicknameupdatd"), {
                    closeButton: false,
                });
                this.props.updateNameProfile(
                    this.state.selectedKeyName,
                    this.state.selectedKeyID,
                    this.props.keyInfo,
                    this.props.password,
                    this.state.tag
                );
            })
            .catch((error) => {
                this.setState({ error: true });
                toast.error(t("profiledetails.nicknamenotupdatd"), {
                    closeButton: false,
                });
            });
    };
    submitEditPassword = () => {
        this.setState({
            submittingPSKReset: true,
        });
        if (this.state.password !== null) {
            let body;
            if (sessionStorage.getItem("showCustomPSK") === "true") {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    CurrentKeyID: this.props.keyID,
                    NewKey: this.state.password,
                };
            } else {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    CurrentKeyID: this.props.keyID,
                    UserPartForNewKey: this.state.password,
                }
            }
            axios
                .post("/subscriberconsole/resetKey", body, {
                    headers: {},
                })
                .then((response) => {
                    this.setState({
                        modalEditPassword: !this.state.modalEditPassword,
                        submittingPSKReset: false,
                    });
                    toast.success(response.data.message, {
                        closeButton: false,
                    });
                    if (sessionStorage.getItem("showCustomPSK") === "true") {
                        this.props.updatePassword(
                            this.props.selectedKeyName,
                            this.props.keyID,
                            this.state.password,
                            this.state.token
                        );
                    } else {
                        this.props.updatePassword(
                            this.props.selectedKeyName,
                            this.props.keyID,
                            this.state.password.split(".")[0],
                            this.state.token
                        );
                    }

                })
                .catch((error) => {
                    this.setState({ error: true });
                    toast.success(error.response.data.message, {
                        closeButton: false,
                        submittingPSKReset: false,
                    });
                });
        } else {
            toast.error(
                "We encountered an error. Please reload the page and try again.",
                {
                    closeButton: false,
                }
            );
        }
    };
    formatDate(date, format, locale) {
        return dateFnsFormat(date, format, { locale });
    }
    copyPassword = () => {
        const { t } = this.props;
        var copyText = document.getElementById("passwordHidden");
        var textArea = document.createElement("textarea");
        textArea.value = copyText.textContent;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        this.setState({ copyText: "Copied" });
        textArea.remove();
        toast.success(t("profiledetails.passwordcopied"), {
            closeButton: false,
        });
    };
    renderDeviceIcon(param) {
        switch (param) {
            case "NetworkDevice":
                return "mobile-alt";
            case "Laptop":
                return "laptop";
            case "Unknown":
                return "question";
            default:
                return "mobile-alt";
        }
    }
    validateForm() {
        if (this.state.password !== null) {
            return this.state.password.split(".")[0].length >= 1;
        }
    }
    passwordValidate = (newpassword) => {
     const value = newpassword;
     const regexNum = /\d/;
     const regexLowercase = /[a-z]/;
     const regexUppercase = /[A-Z]/;
     const regexCharLength = /^.{8,72}$/;
     const regexDot = /[.]/;
     // const userEmail = this.state.userEmail;
     // const userName = userEmail.split("@")[0];
     let count = 0;
     if (regexNum.test(value)===true){
      this.setState({ 
       number: true,
       count: count+1
      });
      count++;
     }else{
      this.setState({ number: false });
     }
     if (regexLowercase.test(value)===true){
      this.setState({ lowercase: true,
       count: count+1 });
      count++;
     }else{
      this.setState({ lowercase: false });
     }
     if (regexUppercase.test(value)===true){
      this.setState({ uppercase: true,
       count: count+1 });
      count++;
     }else{
      this.setState({ uppercase: false });
     }
     // if (regexSymbol.test(value)===true){
     //  this.setState({ symbol: false,
     //   count: count-1 });
     //  count--;
     // }else{
     //  this.setState({ symbol: true });
     // }
     
     if (regexCharLength.test(value)===true){
      this.setState({ charLength: true,
       count: count+1 });
      count++;
     }else{
      this.setState({ charLength: false });
     }
     if (regexDot.test(value)===true){
      this.setState({
       dot: false,
       count: count-1
      });
      count--;
     
    }else{
     this.setState({ dot: true });
    }
     if(count>=4){
      let body = {
       "AccessToken": sessionStorage.getItem("AccessToken"),
       "CurrentKeyID": this.state.selectedKeyID !== undefined
       ? this.props.keyID
       : Object.keys(this.state.sortedKeys[0])[2],
       "NewKey": newpassword,
       "dryRun": true
      }
      // console.log(this.state)
      this.setState({
       loadingPasswordStrength: true
      })
      axios
          .post("/subscriberconsole/resetKey", body, { headers: {} })
          .then((response) => {
            if(response.data.message === "Strong Wi-Fi password. "){
             this.setState({
              count: count + 1,
              loadingPasswordStrength: false,
              passwordInvalid: false
             })
            }else{
             this.setState({
              // count: count - 1,
              loadingPasswordStrength: false,
              passwordInvalid: true
             })
            }
          })
          .catch((error) => {
            this.setState({ 
             error: true,
             loadingPasswordStrength: false, 
             passwordInvalid: true,
             count: count - 1,
            });
            // toast.error(t("profiledetails.passwordnotupdated"), {
            //   closeButton: false,
            // });
          });
     }
     // regexNum.test(value)
     //   ? (this.setState({ number: true }), count++)
     //   : this.setState({ number: false });
     // regexLowercase.test(value)
     //   ? this.setState({ lowercase: true })
     //   : this.setState({ lowercase: false });
     // regexUppercase.test(value)
     //   ? this.setState({ uppercase: true })
     //   : this.setState({ uppercase: false });
     // regexCharLength.test(value)
     //   ? this.setState({ charLength: true })
     //   : this.setState({ charLength: false });
     // !value.toLowerCase().includes(userName.toLowerCase())
     //   ? this.setState({ emailMatch: true })
     //   : this.setState({ emailMatch: false });
    };
    render() {
        const { t } = this.props;
        let password;
        if (this.props.password === null) {
            password = this.props.firstPSK;
        }else{
            password = this.props.password;
        }
        let passwordStrength;
    if(this.state.count<=2){
     passwordStrength = "weak"
    }else if(this.state.count>2 && this.state.count<=4){
     passwordStrength = "average"
    }else{
     passwordStrength = "strong"
    }
    
    // WPA3 status logic
    let wpa3Status = { configured: false, timestamp: null, isWPA3: false };
    
    // Check authentication mechanism from keyInfo
    if (this.props.keyInfo && this.props.keyInfo[0] && this.props.venueName) {
        const venueKeys = this.props.keyInfo[0][this.props.venueName];
        if (venueKeys && venueKeys.AuthenticationMechanism) {
            wpa3Status.isWPA3 = venueKeys.AuthenticationMechanism === "WPA3";
        }
    }
    
    // Check R1ConfiguredUTC from venueUnitPolicyInfo
    if (this.props.venueUnitPolicyInfo && Array.isArray(this.props.venueUnitPolicyInfo)) {
        for (let policy of this.props.venueUnitPolicyInfo) {
            if (policy.NetworkData && policy.NetworkData.R1ConfiguredUTC) {
                wpa3Status.configured = true;
                wpa3Status.timestamp = policy.NetworkData.R1ConfiguredUTC;
                break;
            }
        }
    }
    
        return (
            <>
                {/* <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={10000}
                /> */}
                <MDBModal
                    isOpen={this.state.modalAddProfile}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                >
                    <AddProfile
                        toggleAddProfile={this.toggleAddProfile}
                        keyInfo={this.props.keyInfo}
                        ssidName={this.props.ssidName}
                        password={
                            this.props.password === null
                                ? this.props.firstPSK
                                : this.props.password
                        }
                        keyID={this.props.keyID}
                        updateNameKey={this.props.updateNameKey}
                        updateNameNetwork={this.props.updateNameNetwork}
                        SessionList={this.props.SessionList}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalEditNickname}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                >
                    <MDBModalHeader toggle={this.toggleEditNickname}>
                        <h4>{t("profiledetails.editnicknametitle")}</h4>
                    </MDBModalHeader>
                    <MDBModalBody>
                        <MDBRow>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("profiledetails.nickname")}
                                </label>
                                <input
                                    id="nickname"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    name="selectedKeyName"
                                    value={
                                        this.state.selectedKeyName === null
                                            ? this.props.firstKeyName
                                            : this.state.selectedKeyName
                                    }
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid email.
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <div className="text-right submitButton">
                            <MDBBtn
                                color="danger"
                                onClick={this.submitEditNickname}
                            >
                                {t("profiledetails.submit")}
                            </MDBBtn>
                            <MDBBtn
                                color="danger"
                                onClick={this.toggleEditNickname}
                            >
                                {t("profiledetails.cancel")}
                            </MDBBtn>
                        </div>
                    </MDBModalBody>
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalEditPassword}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                >
                    <MDBModalHeader toggle={this.toggleEditPassword}>
                        <h4>{t("profiledetails.editpasswordtitle")}</h4>
                    </MDBModalHeader>
                    <MDBModalBody>
                        <MDBRow>
                            <MDBCol col="6">
                                <p>{t("profiledetails.warning")}</p>
                                <p>{t("profiledetails.warningdesc")}</p>
                                <p>Please note, it will take up to 5 minutes for the new Wi-Fi password to activate and take effect.</p>
                                <div className="form-group row">
                                    <div className="col-sm-2">
                                        <p>{t("profiledetails.profile")}</p>
                                    </div>
                                    <div className="col-sm-6">
                                     <p>
                                        {this.props.selectedKeyName === null
                                            ? this.props.firstKeyName
                                            : this.props.selectedKeyName}
                                     </p>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-2">
                                        <p>{t("profiledetails.network")}</p>
                                    </div>
                                    <div className="col-sm-6">
                                     <p>
                                        {this.props.ssidName}
                                     </p>
                                    </div>
                                </div>
                                






                                {
                                 sessionStorage.getItem("showCustomPSK") === "false" 
                                 ? 
                                 <>
                                 <p className="wifiDisclaimer">
                                    Enter a new Personal Token below. Your Wi-Fi
                                    password is the combination of your personal
                                    token and your unique ID. For security
                                    purposes, the unique ID cannot be modified.
                                </p>
                                 <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text passwordLabel"
                                >
                                    Personal Token
                                </label>
                                <input
                                    id="editpassword"
                                    className="form-control"
                                    onChange={(e) =>
                                        this.setPassword(
                                            e.target.value,
                                            password === null
                                                ? this.props.firstPSK.split(
                                                      "."
                                                  )[1] === undefined
                                                    ? this.props.token
                                                    : this.props.firstPSK.split(
                                                          "."
                                                      )[1]
                                                : password.split(".")[1],
                                            this.state.token
                                        )
                                    }
                                    name="password"
                                    value={
                                        this.state.password === null
                                            ? this.props.firstPSK.split(".")[0]
                                            : this.state.password.split(".")[0]
                                    }
                                />
                                <span className="password_subscriber">
                                    .
                                    {password === null
                                        ? this.props.firstPSK.split(".")[1] ===
                                          undefined
                                            ? this.props.token
                                            : this.props.firstPSK.split(".")[1]
                                        : password.split(".")[1]}
                                </span>
                                <div className="invalid-feedback">
                                    Please provide a valid password.
                                </div>
                                <br />
                                <br />
                                <p>Your Wi-Fi password</p>
                                <input
                                    id="editpassword2"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    name="password"
                                    value={
                                        this.state.token !== undefined
                                            ? this.state.password === null
                                                ? this.props.firstPSK.split(
                                                      "."
                                                  )[1] === undefined
                                                    ? this.props.firstPSK +
                                                      "." +
                                                      this.props.token
                                                    : this.props.firstPSK
                                                : this.state.password.split(
                                                      "."
                                                  )[0] +
                                                  "." +
                                                  this.state.token
                                            : this.state.password === null
                                            ? this.props.firstPSK
                                            : this.state.password
                                    }
                                />
                                </>
                                 : 
                                 <MDBRow>
                                    <MDBCol className="col-auto pr-3 editPassword">
                                        <label htmlFor="defaultFormLoginEmailEx" className="black-text passwordLabel">
                                            Old Wi-Fi Password
                                        </label>
                                        <input disabled id="editpassword" className="form-control" name="password" value={password} />
                                        <br />
                                        <label htmlFor="defaultFormLoginEmailEx" className="black-text passwordLabel">
                                            New Wi-Fi Password
                                        </label>
                                        <input id="editpassword" className="form-control" onChange={(e) => this.setPassword(e.target.value, this.state.newpsk !== undefined ? this.state.newpsk : this.state.newpsk)} name="password" value={this.state.newpsk} />
                                        <br />
                                        <LinearProgress
                                            value={this.state.count * 20}
                                            // valueBuffer="100"
                                            variant="determinate"
                                            className={passwordStrength}
                                        />
                                        Your password strength is {passwordStrength}
                                    </MDBCol>
                                    <MDBCol className="col-auto pl-1">
                                        

                                        <label htmlFor="defaultFormLoginEmailEx" className="black-text passwordLabel bold">
                                            Password Requirements
                                        </label>
                                        <PasswordConditions
                                            id="editpassword"
                                            className="form-control"
                                            charLength={this.state.charLength}
                                            lowercase={this.state.lowercase}
                                            uppercase={this.state.uppercase}
                                            number={this.state.number}
                                            emailMatch={this.state.emailMatch}
                                            symbol={this.state.symbol}
                                            dot={this.state.dot}
                                        />
                                        {this.state.passwordInvalid ? (
                                            <label htmlFor="defaultFormLoginEmailEx" className="passwordLabel bold invalidPassword" id="invalidPassword">
                                                Our apologies, your chosen password is not valid. Please create a new password.
                                            </label>
                                        ) : (
                                            ""
                                        )}
                                    </MDBCol>
                                </MDBRow>
                                }







                                
                                <div className="invalid-feedback">
                                    Please provide a valid password.
                                </div>
                                {/* <br />
                                <br />
                                <p>{t("profiledetails.newpassword")}</p>
                                <input
                                    id="editpassword2"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    name="password"
                                    value={
                                        this.state.token !== undefined
                                            ? this.state.password === null
                                                ? this.props.firstPSK.split(
                                                      "."
                                                  )[1] === undefined
                                                    ? this.props.firstPSK +
                                                      "." +
                                                      this.props.token
                                                    : this.props.firstPSK
                                                : this.state.password.split(
                                                      "."
                                                  )[0] +
                                                  "." +
                                                  this.state.token
                                            : this.state.password === null
                                            ? this.props.firstPSK
                                            : this.state.password
                                    }
                                /> */}
                            </MDBCol>
                        </MDBRow>
                        <div className="text-right submitButton">
                            <MDBBtn
                                color="danger"
                                disabled={
                                 (passwordStrength !== "strong" 
                                 && sessionStorage.getItem("showCustomPSK") === "true")
                                 || this.state.submittingPSKReset === true  || this.state.password === null
                                 ? true:false}
                                onClick={this.submitEditPassword}
                            >
                                {t("profiledetails.submit")}
                            </MDBBtn>
                            <MDBBtn
                                color="danger"
                                onClick={this.toggleEditPassword}
                            >
                                {t("profiledetails.cancel")}
                            </MDBBtn>
                        </div>
                    </MDBModalBody>
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalDeviceDetails}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                >
                    <DeviceDetails
                        toggleDeviceDetails={this.toggleDeviceDetailsClose}
                        deviceDetails={this.state.deviceDetails}
                    />
                </MDBModal>
                <MDBModalHeader toggle={this.props.toggleManageKey}>
                    <h4>{t("profiledetails.title")}</h4>
                </MDBModalHeader>
                <MDBModalBody style={{ margin: "0px 20px 0px 10px" }}>
                    <MDBRow>
                        <MDBCol sm="6">
                            <div className="form-group row">
                                <div className="col-sm-4">
                                    <p>
                                        <strong>
                                            {t("profiledetails.profile")}
                                        </strong>
                                    </p>
                                </div>
                                <div className="col-sm-6">
                                    <MDBDropdown>
                                        <MDBDropdownToggle nav caret>
                                            <span
                                                className="mr-2"
                                                onClick={this.click}
                                            >
                                                {this.props.selectedKeyName ===
                                                null
                                                    ? this.props.firstKeyName
                                                    : this.props
                                                          .selectedKeyName}
                                            </span>
                                        </MDBDropdownToggle>
                                        <MDBDropdownMenu>
                                            {this.props.keyNameListArray.map(
                                                (value, index) => {
                                                    return (
                                                        <MDBDropdownItem
                                                            onClick={(e) =>
                                                                this.props.updateNameKey(
                                                                    this.props
                                                                        .keyNameListArray[
                                                                        index
                                                                    ][1],
                                                                    this.props
                                                                        .keyNameListArray[
                                                                        index
                                                                    ][0]
                                                                )
                                                            }
                                                        >
                                                            {
                                                                this.props
                                                                    .keyNameListArray[
                                                                    index
                                                                ][1]
                                                            }
                                                        </MDBDropdownItem>
                                                    );
                                                }
                                            )}
                                        </MDBDropdownMenu>
                                    </MDBDropdown>
                                </div>
                                <div className="col-sm-2 formControls">
                                    {this.props.isWPA2 === false ? (
                                        <MDBIcon
                                            icon="edit"
                                            onClick={this.toggleEditNickname}
                                        />
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-4">
                                    <p>
                                        <strong>
                                            {t("profiledetails.network")}
                                        </strong>
                                    </p>
                                </div>
                                <MDBDropdown className="col-sm-6">
                                    <MDBDropdownToggle nav caret>
                                        <span className="mr-2">
                                            {this.props.ssidName}
                                        </span>
                                    </MDBDropdownToggle>
                                    <MDBDropdownMenu>
                                        {this.props.SessionList.map(
                                            (value, index) => {
                                                return (
                                                    <MDBDropdownItem
                                                        onClick={(e) =>
                                                            this.props.updateNameNetwork(
                                                                this.props
                                                                    .SessionList[
                                                                    index
                                                                ][0]["ssid"],
                                                                index
                                                            )
                                                        }
                                                    >
                                                        {
                                                            this.props
                                                                .SessionList[
                                                                index
                                                            ][0]["ssid"]
                                                        }
                                                    </MDBDropdownItem>
                                                );
                                            }
                                        )}
                                    </MDBDropdownMenu>
                                </MDBDropdown>
                            </div>
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <label
                                            htmlFor="defaultFormLoginEmailEx"
                                            className="black-text col-form-label"
                                        >
                                            <strong>
                                                {t("profiledetails.password")}
                                            </strong>{" "}
                                            {/* {this.state.showPassword !== true ? (
												<MDBIcon icon="eye" onClick={this.togglePassword} />
											) : (
                        <MDBIcon
                          icon="eye-slash"
                          onClick={this.togglePassword}
                        />
                      )} */}
                                        </label>
                                    </div>
                                    <div className="col-sm-6">
                                        <p
                                            className="inputBox"
                                            id="password"
                                            style={{ marginBottom: 0 }}
                                        >
                                            {this.state.showPassword !== false
                                                ? password === null
                                                    ? this.props.firstPSK
                                                    : password
                                                : "************"}
                                        </p>
                                        <span id="passwordHidden">
                                            {password === null
                                                ? this.props.firstPSK
                                                : password}
                                        </span>
                                    </div>
                                    <div className="col-sm-2 formControls" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {/* WPA3 Status Badge */}
                                        {wpa3Status.isWPA3 ? (
                                            wpa3Status.configured ? (
                                                <span
                                                    title="Password is active"
                                                    style={{
                                                        backgroundColor: '#28a745',
                                                        color: 'white',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        minWidth: '20px',
                                                        minHeight: '20px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '14px',
                                                        fontWeight: 'bold',
                                                        cursor: 'help',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                </span>
                                            ) : (
                                                <span
                                                    title="Password not configured"
                                                    style={{
                                                        backgroundColor: '#6c757d',
                                                        color: 'white',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        minWidth: '20px',
                                                        minHeight: '20px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '16px',
                                                        fontWeight: 'bold',
                                                        cursor: 'help',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                </span>
                                            )
                                        ) : (
                                            <span
                                                title="Password is active"
                                                style={{
                                                    backgroundColor: '#28a745',
                                                    color: 'white',
                                                    borderRadius: '50%',
                                                    width: '20px',
                                                    height: '20px',
                                                    minWidth: '20px',
                                                    minHeight: '20px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    cursor: 'help',
                                                    flexShrink: 0
                                                }}
                                            >
                                            </span>
                                        )}
                                        {this.props.isWPA2 === false ? (
                                            <MDBIcon
                                                icon="edit"
                                                onClick={
                                                    this.toggleEditPassword
                                                }
                                            />
                                        ) : (
                                            ""
                                        )}
                                        <MDBIcon
                                            icon="copy"
                                            onClick={this.copyPassword}
                                        />
                                    </div>
                                </div>
                            </div>
                        </MDBCol>
                        <MDBCol sm="6">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <p>
                                            <strong>
                                                {t("profiledetails.activated")}
                                            </strong>
                                        </p>
                                    </div>
                                    <div className="col-sm-8">
                                     <p>
                                        {this.props.addedOn === null
                                            ? new Intl.DateTimeFormat("en-US", {
                                                  year: "numeric",
                                                  month: "numeric",
                                                  day: "numeric",
                                              }).format(
                                                  new Date(
                                                      this.props.dateAddedOn
                                                  )
                                              )
                                            : new Intl.DateTimeFormat("en-US", {
                                                  year: "numeric",
                                                  month: "numeric",
                                                  day: "numeric",
                                              }).format(
                                                  new Date(this.props.addedOn)
                                              )}
                                      </p>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <p>
                                            <strong>
                                                {t("profiledetails.recentuse")}
                                            </strong>
                                        </p>
                                    </div>
                                    <div className="col-sm-8">
                                     <p>
                                        {this.props.recent === null
                                            ? this.props.recentDateUsed !==
                                              undefined
                                                ? new Intl.DateTimeFormat(
                                                      "en-US",
                                                      {
                                                          year: "numeric",
                                                          month: "numeric",
                                                          day: "numeric",
                                                      }
                                                  ).format(
                                                      new Date(
                                                          this.props.recentDateUsed
                                                      )
                                                  )
                                                : ""
                                            : this.props.recent !== undefined
                                            ? new Intl.DateTimeFormat("en-US", {
                                                  year: "numeric",
                                                  month: "numeric",
                                                  day: "numeric",
                                              }).format(
                                                  new Date(this.props.recent)
                                              )
                                            : ""}
                                       </p>
                                    </div>
                                </div>
                            </div>
                        </MDBCol>
                    </MDBRow>
                    <MDBRow>
                        <MDBCol sm="12">
                            <p>
                                <strong>Subscriptions</strong>
                            </p>
                            <AllWifiKeysTable
                                venueUnitPolicyInfo={
                                    this.props.venueUnitPolicyInfo
                                }
                            />
                        </MDBCol>
                    </MDBRow>
                    <br />
                    {
                     !this.props.isUbiquiti ?
                     (
                    <MDBRow>
                        <MDBCol sm="6">
                            <p>
                                <strong>{t("profiledetails.devices")}</strong>
                            </p>
                            <div>
                                {Object.keys(this.props.devices).length > 0 ? (
                                    <div
                                        className="devices"
                                        style={{
                                            border: "1px solid #CCC",
                                            padding: "10px",
                                            borderRadius: "5px",
                                            minHeight: "232px",
                                        }}
                                    >
                                        {Object.keys(this.props.devices)
                                            .slice(0, 3)
                                            .map((oneKey, i) => {
                                                return (
                                                    <div
                                                        className="deviceCard"
                                                        onClick={(e) =>
                                                            this.toggleDeviceDetails(
                                                                this.props
                                                                    .devices[
                                                                    oneKey
                                                                ]
                                                            )
                                                        }
                                                    >
                                                        <MDBIcon
                                                            icon={this.renderDeviceIcon(
                                                                this.props
                                                                    .devices[
                                                                    oneKey
                                                                ]["DeviceType"]
                                                            )}
                                                        />
                                                        <div
                                                            className={
                                                                this.props
                                                                    .devices[
                                                                    oneKey
                                                                ][
                                                                    "currentlyOnline"
                                                                ] === true
                                                                    ? "deviceStatusConnected"
                                                                    : "deviceStatusDisconnected"
                                                            }
                                                        ></div>
                                                        <p>
                                                            {
                                                                this.props
                                                                    .devices[
                                                                    oneKey
                                                                ][
                                                                    "UserDefinedHostName"
                                                                ]
                                                            }
                                                        </p>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                ) : (
                                    <MDBCard
                                        style={{
                                            border: "1px solid #CCC",
                                            padding: "10px",
                                            borderRadius: "5px",
                                            minHeight: "232px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            boxShadow: "none",
                                        }}
                                    >
                                        <MDBCardBody
                                            className="messageCardBody1"
                                            style={{ flex: "unset" }}
                                        >
                                            <h4 style={{ color: "#BBB" }}>
                                                {t("profiledetails.nodevices")}
                                            </h4>
                                        </MDBCardBody>
                                    </MDBCard>
                                )}
                            </div>
                        </MDBCol>
                        <MDBCol sm="6">
                            <p>
                                <strong>{t("profiledetails.bandwidth")}</strong>
                            </p>
                            <div
                                style={{
                                    border: "1px solid #CCC",
                                    padding: "10px",
                                    borderRadius: "5px",
                                }}
                            >
                                <Data selectedKeyID={this.props.keyID} />
                            </div>
                        </MDBCol>
                    </MDBRow>
                    ) : ""
                   }
                </MDBModalBody>
                <MDBModalFooter>
                    <div className="text-right">
                        <MDBBtn
                            color="danger"
                            onClick={this.props.toggleManageKey}
                        >
                            OK
                        </MDBBtn>
                    </div>
                </MDBModalFooter>
            </>
        );
    }
}
export default withTranslation()(KeyManage);
